import { APPS_MORE_BANNER_DETAIL, GET_FONTS, PHOTOBOOTH_UPDATE, SNAPUP_DETAILS} from "../reducers/keys";
import { WALLS_DETAILS, MOD_AUTO_COMPLETE, UPDATE_BANNER, PROFANITY, PROFANITY_UPDATE, GET_NETWORK_LIST, GET_FEED_LIST, CREATE_CUSTOM_POST, LIST_CUSTOM_POST, AUTOMOD_LIST, AUTOMOD_STATUS, AUTOMOD_DELETE, CREATE_AUTOMOD, UPDATE_CUSTOM_POSTS, STATUS_UPDATE_CUSTOM_POST, CREATE_CUSTOM_POST_URL, GET_EDIT_CUSTOM_POST, IMAGE_REQUEST_CREATE, IMAGE_DOWNLOAD, IMAGE_REQUEST_LIST, GOOGLE_ANALYTIC, APPS_MORE_FILTERS, CUSTOM_CSS, Get_Collaborators, Add_Collaborator, Delete_Collaborator, Update_Collaborator, Choose_Language, Hashtag_Highlighter, KEY_DELETE, UPDATE_THEME, GET_THEMES_D, Theme_Settting, UpdateCardStyle, UPDATE_TAG_BASED_FILTER, GET_TICKER_DETAILS, ANNOUNCEMENTS_API, UPDATE_TICKER_DETAILS, SUPER_REFRESH,ADD_BACKGROUND, GET_THEME_SETTINGS, INTERACTIVE, QR_SNAPUP_UPDATE, GET_CUSTOM_LANUAGE, UPLOAD_PHOTOBOOTH_SETTINGS, REVIEW_HUB_DOWNLOAD_CSV } from "./api";

import HttpClient from "./http-client";
import store from "../store";
import axios from 'axios';
import { API_URL, Export_UgcUploader_Display, fontVariants, SHARE_CODE, Ugc_Uploade_Display } from "./api";
import { downloadJSONAsCSV, TOAST_ERROR, TOAST_SUCCESS } from "../utils";

export const getAppsMOreDetails = () => {
    const ownerId = localStorage.getItem('ownerId')

    return (dispatch) => {
        new HttpClient() .post(`${WALLS_DETAILS}`, { wallId: Number(localStorage.getItem('wallId')) })
          .then((detailReponse) => {
                dispatch({ type: APPS_MORE_BANNER_DETAIL, payload: detailReponse.data, });
           });
    };
};



export const addBackground = (obj, wallId) =>  new HttpClient().post(`${ADD_BACKGROUND}/${wallId}/${obj.themeId}/${obj.id}`, { ...obj })

export const getCollaborators = () => new HttpClient() .get(`${Get_Collaborators}/${localStorage.getItem('wallId')}`)

export const addCollaborator = ({ emailId, collaboratorRole }) => {
    const { wallData } = store.getState().wallData;

    if (wallData && Object.keys(wallData).length > 0) {
        return new HttpClient() .post(`${Add_Collaborator}/${wallData.wallId}`, { wallName: wallData.wall.name, emailId: emailId, collaboratorRole: collaboratorRole })
    }
    else {
        return null
    }
}

export const deleteCollaborator = (id) =>  new HttpClient() .get(`${Delete_Collaborator}/${id}/${localStorage.getItem('wallId')}`)

export const updateCollaborator = ({ collaboratorId, id, collaboratorRole }) => {
    const { wallData } = store.getState().wallData;
    if (wallData && Object.keys(wallData).length > 0) {
        return new HttpClient() .post(`${Update_Collaborator}/${id}/${wallData.wallId}`, { wallName: wallData.wall.name, collaboratorRole: collaboratorRole, collaboratorId })
    }
    else {
        return null
    }

}

export const chooseLanguage = (data) =>  new HttpClient() .post(`${Choose_Language}/${localStorage.getItem('wallId')}`, { ...data })

export const hashtagHighlighter = (data) =>  new HttpClient() .post(`${Hashtag_Highlighter}/${localStorage.getItem('wallId')}`, { ...data })

export const interactionWall = (data) =>  new HttpClient().post(`${INTERACTIVE}`, data)

export const getFontVariants = () => {
    return (dispatch) => {
        dispatch({ type: GET_FONTS, payload: fontVariants });
    };
};

export const updateThemeSetting = (data) => {
    data = {...data,adminId: localStorage.getItem('Isadmin') ?? localStorage.getItem('ownerId')}
    return new HttpClient().post(`${Theme_Settting}`, data)
}

export const screenShot = (data) =>  new HttpClient().post(`${API_URL}/display/walls/domain-screenshot`, data)

export const updateCardStyle = ({ data, wallId, themeId, personalizationId }) => new HttpClient() .post(`${UpdateCardStyle}/${wallId}/${themeId}/${personalizationId}`, data)

export const updateWidgetBanner = (obj) => new HttpClient().post(`${UPDATE_BANNER}`, { ...obj })


export const getNetworklist = (wallId, planId, type) => {
    const { userData } = store.getState().authenticated;
    var planIdUpdate = planId
    if (userData && Object.keys(userData).length > 0 && userData.UserPlan && Object.keys(userData.UserPlan).length > 0) {
        planIdUpdate = userData.UserPlan.planId
    }
    const dataUpdate = type == 4 ? { wallId: wallId } : {}
    return new HttpClient().post(`${GET_NETWORK_LIST}`,
        {
            'type': 4,
            'planId': `${planIdUpdate}`,
            ...dataUpdate
        }
    );
}

export const getFeedlist = (wallId, network) =>  new HttpClient().get(`${GET_FEED_LIST}/${wallId}/${network}`);

export const deleteCustomPost = (wallId, postId) => new HttpClient().post(`${UPDATE_CUSTOM_POSTS}/${wallId}/${postId}`, { 'action': 'delete', });

export const statusUpdateCustomPost = (wallId, postId, value) =>  new HttpClient().post(`${STATUS_UPDATE_CUSTOM_POST}/${wallId}/${postId}`, { 'action': 'status', 'value': value ? 1 : 0, });

export const geteditPost = (ownerId, postId) =>  new HttpClient().get(`${GET_EDIT_CUSTOM_POST}/${postId}`);

export const getPost = (ownerId, wallId) => new HttpClient().get(`${LIST_CUSTOM_POST}/${wallId}`);

export const updateTheme = (wallId, personalizationId, data) => new HttpClient().post(`${UPDATE_THEME}/${wallId}/${personalizationId}`, data);

export const getThemes = () => new HttpClient().get(`${GET_THEMES_D}/${localStorage.getItem('wallId')}`);

export const customPostsubmit = (ownerId, wallId, data) => {
    if (data.eid) {
        return new HttpClient().post(`${STATUS_UPDATE_CUSTOM_POST}/${wallId}/${data.eid}`, data);
    } else {
        return new HttpClient().post(`${CREATE_CUSTOM_POST}/${wallId}`, data);
    }
}



export const customPostUrlsubmit = (wallId, data) => new HttpClient().post(`${CREATE_CUSTOM_POST_URL}/${wallId}`, data);

export const postUrlsubmit = (ownerId, data) => new HttpClient().post(`${STATUS_UPDATE_CUSTOM_POST}/${ownerId}/${data.eid}`, data);




export const getProfanity = (ownerId, wallId) => {

    return new HttpClient().post(`${PROFANITY}`,
        {
            "ownerId": ownerId,
            "wallId": wallId,
            adminId: localStorage.getItem('Isadmin') ?? localStorage.getItem('ownerId'),
        });
}


export const updateProfanity = (data) => {
    data = {...data, adminId: localStorage.getItem('Isadmin') ?? localStorage.getItem('ownerId')}
    return new HttpClient().post(`${PROFANITY_UPDATE}`, data);
}


export const imageRequestCreate = (ownerId, wallId) => {

    return new HttpClient().post(`${IMAGE_REQUEST_CREATE}`, {
        'ownerId': ownerId,
        'wallId': wallId,
         adminId: localStorage.getItem('Isadmin') ?? localStorage.getItem('ownerId'),
    });
}


export const googleAnaytic = (formData) => {
    return new HttpClient().post(`${GOOGLE_ANALYTIC}`, formData);
}

export const imageDownload = (ownerId) => {
    return new HttpClient().get(`${IMAGE_DOWNLOAD}/${ownerId}`);
}

export const imageRequestList = (ownerId) => {
    return new HttpClient().get(`${IMAGE_REQUEST_LIST}/${ownerId}`);
}

export const getAutoModList = () => {
    return new HttpClient().post(`${AUTOMOD_LIST}`, {
        adminId: localStorage.getItem('Isadmin') ?? localStorage.getItem('ownerId'),
        "ownerId": localStorage.getItem('ownerId'),
        "wallId": localStorage.getItem('wallId'),
    })

}

export const statusAutoModRule = (id, status) => {
    return new HttpClient().post(`${AUTOMOD_STATUS}`, {
        "ownerId": localStorage.getItem('ownerId'),
        "wallId": localStorage.getItem('wallId'),
        "id": id,
        "status": status,
        adminId: localStorage.getItem('Isadmin') ?? localStorage.getItem('ownerId'),
    })
}
export const deleteAutoModRule = (id) => {
    return new HttpClient().post(`${AUTOMOD_DELETE}`, {
        "ownerId": localStorage.getItem('ownerId'),
        "wallId": localStorage.getItem('wallId'),
        "id": id,
        adminId: localStorage.getItem('Isadmin') ?? localStorage.getItem('ownerId'),
    })
}
export const createAutoModRule = (obj) => {
    obj = {...obj, adminId: localStorage.getItem('Isadmin') ?? localStorage.getItem('ownerId')}
    return new HttpClient().post(`${CREATE_AUTOMOD}`, obj)
}

//UPDATE FILTERS
export const updateFilter = ({ networkStatus, ownerId, wallId, pId, adminId, filter_Id }) => {

    return new HttpClient().post(`${APPS_MORE_FILTERS}`, {
        'ownerId': ownerId,
        'wallId': wallId,
        'filter_type': filter_Id,
        'pid': pId,
        adminId: localStorage.getItem('Isadmin') ?? localStorage.getItem('ownerId'),
        'networkStatus': networkStatus
    });
}

export const updateCutomCSS = (css, cssStatus) => {
    const { detail } = store.getState().appsMore;
    return new HttpClient().post(`${CUSTOM_CSS}`,
        {
            "ownerId": localStorage.getItem('ownerId'),
            "wallId": localStorage.getItem('wallId'),
            adminId: localStorage.getItem('Isadmin') ?? localStorage.getItem('ownerId'),
            "id": detail.wall.Personalization.id,
            "css": css,
            "cssStatus": cssStatus
        }
    );
}


export const DeleteKeys = () =>  new HttpClient().get(`${KEY_DELETE}/${localStorage.getItem('wallId')}`)

export const updateTagBasedFilter = (data) => new HttpClient().post(`${UPDATE_TAG_BASED_FILTER}`, data);


export const getTickerDetails = () =>  new HttpClient().get(`${GET_TICKER_DETAILS}/${localStorage.getItem('wallId')}`)

export const updateTickerDetails = (data) => new HttpClient().post(`${UPDATE_TICKER_DETAILS}/${localStorage.getItem('wallId')}`, { ...data })

export const getAnnouncementDetails = () => new HttpClient().get(`${ANNOUNCEMENTS_API}/${localStorage.getItem('wallId')}`)

export const addNewAnnouncements = (data) => new HttpClient().post(`${ANNOUNCEMENTS_API}`, { ...data })

export const deleteAnnouncement = (id) => new HttpClient().delete(`${ANNOUNCEMENTS_API}/${id}`)

export const updateAnnouncements = (id, data) => new HttpClient().put(`${ANNOUNCEMENTS_API}/${id}`, { ...data })

export const superRefresh = (wallID) => new HttpClient().post(`${SUPER_REFRESH}`, { object: 'wall', type: 'refresh', wallId: wallID, content: "", url: "" })

export const getThemeSettings = (wallId, themeId) => new HttpClient().post(`${GET_THEME_SETTINGS}`, { wallId, themeId });

export const saveRule = (data) => new HttpClient().post(CREATE_AUTOMOD, data);

export const ExportUgcUploader = (ID) =>   window.location.href=`${Export_UgcUploader_Display}/${ID}`

export const shareCode = (code) =>  new HttpClient().post(`${SHARE_CODE}`, { 'htmlCode': code.htmlCode, 'type': code.type, 'email': code.email, })
export const UPDATE_QR_SETTING = ({ data }) => new HttpClient().post(QR_SNAPUP_UPDATE, data)

export const SNAPUP_UPDATE = (obj, callBack = () => {}) => {
    return async (dispatch) => {
        try {
            const { data: { responseCode, responseData, responseMessage } } = await new HttpClient().post(Ugc_Uploade_Display, obj);

            if (responseCode === 200) {
                dispatch({ type: SNAPUP_DETAILS, payload: obj });
                TOAST_SUCCESS(responseData);
            } else {
                TOAST_ERROR(responseMessage || "An error occurred");
            }
        } catch (error) {
            console.error("Error in SNAPUP_UPDATE:", error);
            TOAST_ERROR("Something went wrong. Please try again later.");
        } finally {
            callBack();
        }
    };
};

export const CUSTOM_LANUAGE = (callBack) => new HttpClient().get(GET_CUSTOM_LANUAGE).then(res => callBack(res?.data))

export const UPDATE_PHOTOBOOTH = (obj, callBack = () => {}) => {
    return async (dispatch) => {
        try {
            const { data: { responseCode, responseData, responseMessage } } = await new HttpClient().post(UPLOAD_PHOTOBOOTH_SETTINGS, obj);

            if (responseCode === 200) {
                dispatch({ type: PHOTOBOOTH_UPDATE, payload: obj });
                TOAST_SUCCESS(responseData);
            } else {
                TOAST_ERROR(responseMessage || "An error occurred");
            }
        } catch (error) {
            console.error("Error in SNAPUP_UPDATE:", error);
            TOAST_ERROR("Something went wrong. Please try again later.");
        } finally {
            callBack();
        }
    };
};

export const getSnapUpData = async (callBack) => {
    try {
        const response = await new HttpClient().post(REVIEW_HUB_DOWNLOAD_CSV, { wallId: localStorage.getItem('wallId') });
        const data = response?.data?.responseData?.posts ?? [];
        if(data?.length) downloadJSONAsCSV(data);
    } catch (error) {
        TOAST_ERROR("Something went wrong. Please try again later.");
    } finally {
        setTimeout(callBack, 500);
    }
}